export * from './logos';
import { buttonIcons, ButtonIconsInterface } from './buttonIcons';
import { categoryIcons, CategoryIconsInterface } from './categories';
import { currencyIcons, CurrencyIconsInterface } from './currency';
import { generalIcons, GeneralIconsInterface } from './generalIcons';
import { levelIcons, LevelIconsInterface } from './levels';
import { SideNavIconsInterface, sideNavIcons } from './sidenav';
import { socialIcons, SocialIconsInterface } from './socials';

type IconsType = CurrencyIconsInterface &
	LevelIconsInterface &
	ButtonIconsInterface &
	SideNavIconsInterface &
	GeneralIconsInterface &
	SocialIconsInterface &
	CategoryIconsInterface;

export const icons: IconsType = {
	...currencyIcons,
	...buttonIcons,
	...levelIcons,
	...sideNavIcons,
	...levelIcons,
	...generalIcons,
	...socialIcons,
	...categoryIcons,
};

export const getIcon = (code: string | undefined) => {
	if (!code) return null;

	const IconComponent = icons[code.toLowerCase()];

	if (IconComponent) {
		return <IconComponent />;
	} else {
		return null;
	}
};

// export const getIcon = (code: string) => {
// 	if (!code) return null;

// 	const formattedKey = code
// 		.replace(/([-_]\w)/g, (match) => match[1].toUpperCase())
// 		.replace(/^./, (match) => match.toLowerCase());

// 	const IconComponent = icons[formattedKey];

// 	return IconComponent ? <IconComponent /> : null;
// };
